module.exports = __webpack_public_path__ + "media/images/lb/704-8d3d14961b56364f4f1197c2f79dfe46.svg";